"use client";

import React from 'react';
import Image from 'next/image';

const SimpleFooter = () => {
  return (
    <footer className="w-full bg-gradient-to-b from-[#0a0a0a] to-[#000000] relative z-10">
      <div className="mx-auto max-w-7xl px-3 sm:px-4 md:px-6 lg:px-8 py-3 sm:py-4 md:py-6">
        {/* Separator line with gradient */}
        <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-500 to-transparent mb-4 sm:mb-6"></div>
        
        {/* Main footer bar */}
        <div 
          className="rounded-xl sm:rounded-2xl lg:rounded-full px-3 sm:px-6 md:px-8 lg:px-12 py-3 sm:py-4 backdrop-blur-lg border border-white/20 shadow-2xl transition-all duration-300 hover:border-white/30"
          style={{ 
            backgroundColor: 'rgba(45, 45, 45, 0.6)',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)'
          }}
        >
          <div className="flex flex-col lg:flex-row justify-between items-center gap-3 sm:gap-4 lg:gap-8">
            {/* Copyright - Centered on mobile, left on desktop */}
            <div className="text-center lg:text-left order-2 lg:order-1 w-full lg:w-auto">
              <p className="text-[10px] xs:text-xs sm:text-sm md:text-base text-gray-300 font-light tracking-wide leading-relaxed">
                Copyright © All Rights Reserved. 2025
              </p>
            </div>
            
            {/* Powered by - Centered, with enhanced styling */}
            <div className="flex items-center gap-1.5 sm:gap-2 order-1 lg:order-2">
              <span className="text-[10px] xs:text-xs sm:text-sm md:text-base text-gray-400 font-light whitespace-nowrap">Powered by</span>

                <Image
                  src="/images/Nexit.png"
                  alt="NEXIT Logo"
                  width={32}
                  height={32}
                  className="h-16 w-16 object-contain"
                  priority
                />
       
            </div>
            
            {/* Navigation links - Responsive layout */}
            <nav className="flex flex-wrap justify-center lg:justify-end gap-2 sm:gap-3 md:gap-4 lg:gap-6 items-center order-3 w-full lg:w-auto">
              <a 
                href="#" 
                className="text-[10px] xs:text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-all duration-300 hover:scale-105 relative group whitespace-nowrap"
              >
                Content Privacy
                <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-white transition-all duration-300 group-hover:w-full"></span>
              </a>
              <span className="hidden xs:inline text-gray-600 text-xs">•</span>
              <a 
                href="/privacy-policy" 
                className="text-[10px] xs:text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-all duration-300 hover:scale-105 relative group whitespace-nowrap"
              >
                Privacy Policy
                <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-white transition-all duration-300 group-hover:w-full"></span>
              </a>
              <span className="hidden xs:inline text-gray-600 text-xs">•</span>
              <a 
                href="#" 
                className="text-[10px] xs:text-xs sm:text-sm md:text-base text-gray-300 hover:text-white transition-all duration-300 hover:scale-105 relative group whitespace-nowrap"
              >
                Terms of Service
                <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-white transition-all duration-300 group-hover:w-full"></span>
              </a>
            </nav>
          </div>
        </div>
        
        {/* Additional bottom padding */}
        <div className="h-1 sm:h-2"></div>
      </div>
    </footer>
  );
};

export default SimpleFooter;
